import { useLocation } from 'react-router-dom';
import { Suspense } from 'react';
import useSWR from 'swr';
import { QContainer, QThemeProvider } from '@kw/quokka-ui';
import { useLocalStorage } from '../../../utils/useLocalStorage';
import { fetchService } from '../../../utils/fetchService';
import { ErrorBoundary } from './ErrorBoundary';
import { SarifReportContent } from './SarifReportContent';
import { ActivityIndicator } from '../ActivityIndicator';

export default function SarifReport() {
  const location = useLocation();

  const { analysisId, backQParams } = Object.fromEntries(new URLSearchParams(location.search));

  const [accessToken = ''] = useLocalStorage('accessToken', '');

  if (!analysisId) {
    return <div>analysisId missing</div>;
  }
  return (
    <ErrorBoundary fallback={<h2>Could not load report</h2>}>
      <Suspense fallback={<ActivityIndicator active={true} message="Loading Report..." subtitle="This may take up to 1 minute" />}>
        <ReportLoader analysisId={analysisId} accessToken={accessToken} backQParams={backQParams}></ReportLoader>
      </Suspense>
    </ErrorBoundary>
  );
}

function ReportLoader({ analysisId, accessToken, backQParams }) {
  // load data for previously analyzed apps
  const { data: reportLoaded } = useSWR(`/eval/results/${analysisId}/is-data-loaded`, path => fetchService(path, accessToken), {
    suspense: true,
  });

  return (
    <QThemeProvider>
      <QContainer
        sx={{
          paddingTop: '16px',
          maxWidth: '100% !important',
          display: 'flex',
          flexDirection: 'column',
          rowGap: 2,
          overflow: 'auto',
          paddingBottom: '0px',
        }}
      >
        <Suspense fallback={<ActivityIndicator active={true} message="Rendering Content..." />}>
          <SarifReportContent analysisId={analysisId} accessToken={accessToken} backQParams={backQParams}></SarifReportContent>
        </Suspense>
      </QContainer>
    </QThemeProvider>
  );
}
